<template>
    <div class="flex items-center relative">
        <div
            class="absolute left-0 flex justify-center pl-4"
            :class="{ 'disabled': disabled }"
            @click="focus"
            v-if="$slots.before"
        >
            <slot name="before" />
        </div>
        <input
            class="form-input"
            :class="[classes, { 'pl-10': $slots.before, 'pr-10': $slots.after, 'focus': isFocused, 'text-gray-300 bg-gray-50': disabled }]"
            :disabled="disabled"
            :placeholder="placeholder"
            :readonly="readonly"
            :type="type"
            :value="value"
            ref="input"
            @blur="onBlur"
            @click="$emit('click')"
            @focus="onFocus"
            @input="$emit('input', $event.target.value)"
            @keypress.enter="$emit('enter-pressed', $event.target.value)"
        >
        <div
            class="absolute right-0 flex justify-center pr-4"
            :class="{ 'disabled': disabled }"
            @click="focus"
            v-if="$slots.after"
        >
            <slot name="after" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NioInput',

        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: '',
            },
            type: {
                type: String,
                default: 'text',
            },
            value: {
                default: '',
                required: true,
                validator: value => typeof value === 'string' || value === null,
            },
            classes: {
                type: [String, Array, Object],
                default: '',
            },
        },

        data() {
            return {
                isFocused: false,
            };
        },

        methods: {
            async focus() {
                await this.$nextTick();

                this.$refs.input.focus();
            },

            onFocus() {
                this.isFocused = true;
                this.$emit('focus');
            },

            onBlur() {
                this.isFocused = false;
                this.$emit('blur');
            },
        },
    };
</script>
